import styled from 'styled-components';

export const Label = styled.div`
  white-space: nowrap;
  font-size: ${p => p.small ? '12px' : '16px'};
  font-weight: ${p => p.small ? '600' : '400'};
  color: ${window?.settings?.secondary_color ?? '#04333b'};
`;
